import React from 'react';

interface BadgeProps {
  fillColor: string;
  strokeColor: string;
  textColor: string;
  displayText: string;
  width?: number | undefined;
  height?: number | undefined;
}

export const GenericTextBadge: React.FC<BadgeProps> = ({
  fillColor,
  strokeColor,
  textColor,
  displayText,
  width = 80,
  height = 30,
}) => {
  const fontSize = Math.min(height * 0.4, 14);
  const borderRadius = Math.min(width, height) * 0.2;

  return (
    <svg width={width} height={height} xmlns='http://www.w3.org/2000/svg'>
      <rect
        x='1'
        y='1'
        rx={borderRadius}
        ry={borderRadius}
        width={width - 2}
        height={height - 2}
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={'2'}
      />
      <text
        x={width / 2}
        y={height / 2}
        dy={'0.15em'} // shifts the text down a bit, because it's centered too high
        fontSize={fontSize}
        textAnchor={'middle'}
        fill={textColor}
        fontFamily={'Arial, sans-serif'}
        fontWeight={'bold'}
        dominantBaseline={'middle'}
      >
        {displayText}
      </text>
    </svg>
  );
};
